<template>
  <div class="comment-item">
    <img class="comment-item__avatar" :src="comment.avatar" alt="头像" />
    <div class="comment-item__body">
      <div class="comment-item__header">
        <span class="comment-item__name">{{ comment.name }}</span>
      </div>
      <p class="comment-item__text">{{ comment.text }}</p>
      <div class="comment-item__footer">
        <span class="comment-item__time">{{ comment.time }}</span>
        <span
          class="comment-item__reply"
          :class="{ 'comment-item__reply--disabled': !isLoggedIn }"
          @click="onReplyClick"
        >
          回复
        </span>
        <span class="comment-item__likes">
          <i class="comment-item__like-icon">👍</i>
          {{ comment.likes }}
        </span>
      </div>

      <!-- 回复输入框 -->
      <div v-if="showReplyBox" class="comment-item__reply-box">
        <input
          v-model="replyText"
          class="comment-item__reply-input"
          type="text"
          placeholder="回复..."
          @keyup.enter="onSubmitReply"
        />
        <button
          class="comment-item__reply-btn"
          :class="{ 'comment-item__reply-btn--disabled': !replyText.trim() }"
          :disabled="!replyText.trim()"
          @click="onSubmitReply"
        >
          回复
        </button>
      </div>

      <!-- 嵌套回复列表 -->
      <div v-if="comment.replies && comment.replies.length > 0" class="comment-item__replies">
        <div
          v-for="(reply, rIdx) in comment.replies"
          :key="rIdx"
          class="comment-item__reply-item"
        >
          <img class="comment-item__reply-avatar" :src="reply.avatar" alt="头像" />
          <div class="comment-item__reply-body">
            <span class="comment-item__reply-name">{{ reply.name }}</span>
            <p class="comment-item__reply-text">{{ reply.text }}</p>
            <span class="comment-item__reply-time">{{ reply.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommentItem',
  props: {
    comment: {
      type: Object,
      required: true
      // { avatar, name, text, time, likes, replies }
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showReplyBox: false,
      replyText: ''
    };
  },
  methods: {
    onReplyClick() {
      if (!this.isLoggedIn) return;
      this.showReplyBox = !this.showReplyBox;
      if (!this.showReplyBox) {
        this.replyText = '';
      }
    },
    onSubmitReply() {
      if (!this.replyText.trim()) return;
      this.$emit('reply', { comment: this.comment, text: this.replyText });
      this.replyText = '';
      this.showReplyBox = false;
    }
  }
};
</script>

<style scoped>
.comment-item {
  display: flex;
  padding: 24px 0;
  border-bottom: 1px solid #eeeeee;
}

.comment-item__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 16px;
}

.comment-item__body {
  flex: 1;
}

.comment-item__name {
  color: var(--color-text-gray);
  font-size: var(--font-sm);
  font-family: var(--font-primary);
  line-height: 22px;
}

.comment-item__text {
  color: var(--color-text-dark);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  line-height: 32px;
  margin: 12px 0 16px;
  word-break: break-all;
}

.comment-item__footer {
  display: flex;
  align-items: center;
  color: var(--color-text-light);
  font-size: var(--font-xs);
  font-family: var(--font-primary);
}

.comment-item__time {
  margin-right: 16px;
}

.comment-item__reply {
  margin-right: auto;
  cursor: pointer;
}

.comment-item__reply--disabled {
  color: #cccccc;
  cursor: not-allowed;
}

.comment-item__likes {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.comment-item__like-icon {
  font-style: normal;
  margin-right: 6px;
  font-size: var(--font-sm);
}

/* 回复输入框 */
.comment-item__reply-box {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.comment-item__reply-input {
  flex: 1;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #dddddd;
  border-radius: 24px;
  background-color: var(--color-white);
  color: var(--color-text-dark);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  outline: none;
}

.comment-item__reply-input::placeholder {
  color: var(--color-text-light);
}

.comment-item__reply-btn {
  width: 80px;
  height: 48px;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.comment-item__reply-btn--disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* 嵌套回复列表 */
.comment-item__replies {
  margin-top: 16px;
  padding: 16px;
  background-color: #f7f7f7;
  border-radius: 8px;
}

.comment-item__reply-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #eeeeee;
}

.comment-item__reply-item:last-child {
  border-bottom: none;
}

.comment-item__reply-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 12px;
}

.comment-item__reply-name {
  color: var(--color-text-gray);
  font-size: var(--font-xs);
  font-family: var(--font-primary);
}

.comment-item__reply-text {
  color: var(--color-text-dark);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  line-height: 28px;
  margin: 8px 0;
  word-break: break-all;
}

.comment-item__reply-time {
  color: var(--color-text-light);
  font-size: var(--font-xs);
  font-family: var(--font-primary);
}
</style>
